/*
----------------------------
Module - smp-language-switcher
----------------------------
*/

import $ from 'jquery';

(function () {
    'use strict';

    squiz.fn.languageSwitcher = function() {

        function toggleLanguage(language) {

            // Translatable tags will have data-english or data-tereo.
            // It is important that the values of the data-language attributes on the buttons have either english or tereo
            var $translatable_tags = $("[data-" + language + "]");

            if ($translatable_tags.length) {

                $translatable_tags.each(function() {

                    var $tag = $(this);
                    var switched_language_value = $tag.data(language);
    
                    if ($tag.is("img")) {
    
                        // If image tag, then switch the src
                        $tag.prop("src", switched_language_value);
    
                    } else {
    
                        if (switched_language_value) {

                            // Switch the inner text only if there was a value stored in the attributes
                            $tag.text(switched_language_value);

                        }

                    }
    
                    // This is mainly for the page header
                    // Theres CSS dependent on what the value of this attribute is
                    $tag.attr("data-current-language", language);
    
                });

                // Set session cookie to store current language
                squiz.fn.setCookie("language", language);

            }
            
        }

        function getButtonLanguage($button) {

            var language = $button.data("language");

            return language;

        }

        function buttonClicked(event) {

            var $clicked_button = $(event.target);
            
            var clicked_button_language = getButtonLanguage($clicked_button);

            var current_language_mode = getButtonLanguage($language_switcher_buttons.filter("[aria-pressed='true']"));

            if (current_language_mode !== clicked_button_language) {
                $language_switcher_buttons.attr("aria-pressed", "false");
                $clicked_button.attr("aria-pressed", "true");

                toggleLanguage(clicked_button_language);

            }

        }

        function setupButtons() {

            $language_switcher_buttons = $language_switcher_wrapper.find(".smp-language-switcher__button");
            
            if ($language_switcher_buttons.length) {
                
                $language_switcher_buttons.click(function(event) {

                    buttonClicked(event);

                });

            }

        }

        function init() {

            $language_switcher_wrapper = $(".smp-language-switcher");

            if ($language_switcher_wrapper.length) {

                setupButtons();

            }

        }

        var $language_switcher_wrapper;
        var $language_switcher_buttons;
        
        return {
            init: init
        }

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        squiz.fn.languageSwitcher.init();
    });

}());
